<template>
  <div class="appBox">
    <h3 style="text-align:center;">红狮金业有限公司</h3>
    <div class="line"></div>
    <h1>公司简介</h1>
    <p>
        红狮金业有限公司（简称：红狮智富），英文名Hong Kong Red Lion Capital Limited，成立于2010年，总部位于香港，是一家跨国性金融企业集团，是香港黄金交易所认可的贵金属网上交易专业营运商，专营伦敦金及伦敦银的电子交易。现独立经营自有网站（红狮金业）与app（红狮）。红狮金业有限公司拥有专业的投资团队，为客户提供优质的服务和咨询。<br>
红狮智富业务涉及投资、保险等领域，在全球5个不同城市均设有办事处，经营伦敦金、伦敦银等贵金属业务。
    </p>
    <ul>
      <li>
        <span>公司名称</span> ：红狮金业有限公司
      </li>
      <li>
        <span>外文名</span> ：RED LION BULLION LIMITED
      </li>
      <li>
        <span>所属行业</span> ：贵金属运营
      </li>
      <li>
        <span>成立时间</span> ：2010年04月26日
      </li>
      <li>
        <span>总部地点</span> ：中国·香港
      </li>
      <li>
        <span>经营范围</span> ：黄金理财、黄金买卖等
      </li>
      <li>
        <span>公司口号</span> ：红狮智富，智投全球
      </li>
      <li>
        <span>牌照编号</span> ：081号
      </li>
    </ul>
    <h1>贵金属资质</h1>
    <p>
        红狮金业有限公司是香港黄金交易所的AA类行员，行员编号：081，并拥有黄金及白银的交易和投资牌照，所有交易活动均受到香港黄金交易所的认可和监管，同时受到香港法律的管制。红狮金业有限公司为客户提供多种黄金及白银产品，以及专业的投资咨询和市场分析，让客户在安全自由的环境中为自己的财富创造最大价值。
    </p>
    <h1>业务介绍</h1>
    <p>
        红狮金业有限公司作为专业的金银投资交易运营商，致力于帮助投资者以低成本交易和灵活的操作方式。<br>
贵金属交易是一种高端的投资方式，为了让更多的投资者能够参与到贵金属交易中来，红狮金业有限公司推出了多样化的黄金和白银产品，满足不同客户的需求。
    </p>
    <h1>信息安全</h1>
    <p>
        红狮金业有限公司针对客户的数据信息安全，采用了先进的安全技术，将客户的所有数据信息存储在与外界隔绝的数据库中。所有工作人员都签署了保密协议，不得向外界泄露任何信息，一经发现，将追究其法律责任。红狮金业有限公司也不会向任何第三方的机构或个人透露客户的信息数据。客户的个人数据和交易信息都享有最高级别的保护。同时红狮金业有限公司也建议客户本人保护好自己的信息数据。建议定期修改密码，不要对外透露信息数据。
    </p>
    <h1>
        公司优势
    </h1>
    <p>
        <b>产品优势：</b>可以买入或卖出黄金和白银，双向交易，可以24小时网上交易，随时掌握市场动态。交易价格公开公正，透明度高。
    </p>
    <p>
        <b>信誉优势：</b>红狮金业有限公司拥有稳定的平台系统及交易数据，为客户提供先进高效的交易和投资服务，公平可靠。
    </p>
    <p>
        <b>资金优势：</b><br>
        （1）可以通过网上银行汇款，10分钟到账，实时注资交易。<br>
        （2）不用支付注资手续费，进一步降低成本。<br>
        （3）可以24小时随时取款，不限次数及金额。<br>
        （4）取款2小时到账，随时掌控资金流向。
    </p>
    <p>
        <b>服务优势：</b><br>
        （1）红狮金业有限公司有24小时在线客服，全年无休。<br>
        （2）每笔取款专人跟进，取款到账通知。<br>
        （3）红狮金业有限公司在APP和PC端均提供从入门到高级的网上教学视频和专业分析师教学直播，简单易懂。<br>
        （4）红狮金业有限公司提供第一手金融信息，助客户掌握行情走势。<br>
        （5）红狮金业有限公司提供专业的投资咨询和市场分析，帮助客户制定合适的投资策略。
    </p>
    <p>
        <b>交易优势：</b><br>
        （1）24小时不间断交易，把握每个行情起伏。随时建仓平仓，每一个操作实时执行。<br>
        （2）实时交易，可以买升买跌，杠杆100倍，开户只需预存50美元，佣金手续费全免。<br>
        （3）每笔交易价格受香港黄金交易所认证，客户资金受香港黄金交易所监督。
    </p>
  </div>
</template>

<script>
export default {
  name:'Conpany',
  created(){
    // 传参控制显示顶部和底部
    this.$emit('controlShow', false);
  }
}
</script>

<style lang="less" scoped>
  .appBox{
    width: 1138px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 50px 0 110px;
    text-align: left;
    h3{
      font-size: 24px;
    }
    .line{
      width: 100%;
      height: 1px;
      background-color: #eaeaea;
      margin: 40px auto 60px;
    }
    ul{
      li{
        letter-spacing: 1px;
        color: #6d6d6d;
        span{
          color: #fe0100;
        }
      }
    }
  }

  /* ---------------- wap端(≤768px) ---------------- */
  @media screen and (max-width: 768px) {
    .appBox{
      width: 100%;
      padding: 25px 12px 40px;
      h3{
        font-size: 19px;
      }
      h1{
        font-size: 18px;
        margin: 25px 0 12px;
      }
      p{
        font-size: 14px;
        line-height: 24px;
        text-align: justify;
      }
      .line{
        margin: 20px auto 25px;
      }
      ul{
        li{
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0;
          margin-bottom: 8px;
        }
      }
    }
  }
</style>